enum WebSocketCloseCode {
  NORMAL_CLOSURE = 1000,
  GOING_AWAY = 1001,
  NO_STATUS = 1005,
  ABNORMAL_CLOSURE = 1006,
}

enum TransitionTypes {
  slideOut = 'slide-out',
  fadeOut = 'fade-out',
}

enum Symbols {
  plus = '+',
  minus = '-',
  star = '*',
  caret = '^',
  at = '@',
}

enum MenuStages {
  PLAYGROUND = 'PLAYGROUND',
  PRELIVE = 'PRELIVE',
  LIVE = 'LIVE',
}

enum MenuStagesLabel {
  PLAYGROUND = 'Draft',
  LIVE = 'Live',
  PRELIVE = '',
}

enum NodeEnv {
  production = 'PRODUCTION',
  staging = 'STAGING',
  development = 'DEVELOPMENT',
  sandbox = 'SANDBOX',
  test = 'TEST',
}

enum Routes {
  taskRouter = 'task-router',
}

enum LogLevel {
  log = 'log',
  debug = 'debug',
  info = 'info',
  warn = 'warn',
  error = 'error',
}

enum ArrowKeys {
  arrowUp = 'ArrowUp',
  arrowLeft = 'ArrowLeft',
  arrowRight = 'ArrowRight',
  arrowDown = 'ArrowDown',
}

enum TranscriptTypes {
  AI = 'AI',
  CX = 'CX',
}
enum CartExpandCollapseState {
  MANUAL_EXPAND,
  MANUAL_COLLAPSE,
  AUTO_COLLAPSE,
  AUTO_EXPAND,
}

enum ItemCartActionButtons {
  DECREASE_QUANTITY,
  INCREASE_QUANTITY,
  DUPLICATE,
  REMOVE,
}

export {
  ArrowKeys,
  LogLevel,
  MenuStages,
  MenuStagesLabel,
  NodeEnv,
  Routes,
  Symbols,
  TranscriptTypes,
  TransitionTypes,
  CartExpandCollapseState,
  ItemCartActionButtons,
  WebSocketCloseCode,
};
